import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { forEach as _forEach, find as _find } from 'lodash';

import EntityPropsUpdater from 'component/EntityPropsUpdater';
import List from 'components/List';

import FormInput from 'components/forms/FormInput';
import FormSwitchery from 'components/forms/FormSwitchery';

import ItemAttribute from 'components/layout/item/ItemAttribute';

class VariantData extends EntityPropsUpdater {
  render() {
    const { entity, entityLoaded, intl, disabled, inModal, attributeList } = this.props;
    const messages = intl.messages;

    let variantAttributeList = [];
    if (this.props.itemEntity !== undefined && !attributeList.pending) {
      const variantAttributes = this.props.itemEntity.getVariants().getAttributes();

      if (entityLoaded && variantAttributes !== null) {
        _forEach(variantAttributes, (variantAttribute, i) => {
          const attribute = _find(attributeList.data.list, ['id', variantAttribute.getId()]);

          if (attribute) {
            variantAttributeList.push(
              <ItemAttribute
                key={i}
                index={i}
                attribute={attribute}
                entity={entity}
                changeEntity={this.props.changeEntity}
                disabled={disabled}
              />
            );
          }
        });
      }
    }

    return (
      <div class="clearfix">
        {entityLoaded && this.props.itemEntity !== undefined && (
          <Row>
            <List
              noRender
              listName="categoryAttributes"
              url="/api/attributes.json"
              urlData={{ filters: { categories: this.props.itemEntity.getCategory().getId() } }}
              list={attributeList}
              resPerPage={200}
            />

            <Col xs={12} md={inModal ? 12 : 6}>
              <div class="panel panel-transparent">
                <div class="panel-body">
                  <p className="form-group-title">{messages.variant}</p>
                  <div class="form-group-attached">
                    {variantAttributeList}
                  </div>
                  <p>&nbsp;</p>
                  <p>Lieferzeiten</p>
                  <div className="form-group-attached">
                    <FormInput
                      label='Standard (Freitext z.B.: 3-4 Tage)'
                      name="standard"
                      value={entity.getDeliveryTimes().getStandardTo()}
                      meta={entity.getDeliveryTimes().getStandardToMetaInformation()}
                      validation={entity.getDeliveryTimes().getStandardToValidationResult()}
                      onChange={(name, value) => this.updateEntity(name, value, ['deliveryTimes'])}
                      disabled={disabled}
                    />
                    <FormInput
                      label='Express (Freitext z.B.: 3-4 Tage)'
                      name="express"
                      value={entity.getDeliveryTimes().getExpressTo()}
                      meta={entity.getDeliveryTimes().getExpressToMetaInformation()}
                      validation={entity.getDeliveryTimes().getExpressToValidationResult()}
                      onChange={(name, value) => this.updateEntity(name, value, ['deliveryTimes'])}
                      disabled={disabled}
                    />
                    <FormInput
                      label='Overnight (Freitext z.B.: 3-4 Tage)'
                      name="overnight"
                      value={entity.getDeliveryTimes().getOvernightTo()}
                      meta={entity.getDeliveryTimes().getOvernightToMetaInformation()}
                      validation={entity.getDeliveryTimes().getOvernightToValidationResult()}
                      onChange={(name, value) => this.updateEntity(name, value, ['deliveryTimes'])}
                      disabled={disabled}
                    />
                    <FormInput
                      label='Same Day (Freitext z.B.: 3-4 Tage)'
                      name="sameday"
                      value={entity.getDeliveryTimes().getSameday()}
                      meta={entity.getDeliveryTimes().getSamedayMetaInformation()}
                      validation={entity.getDeliveryTimes().getSamedayValidationResult()}
                      onChange={(name, value) => this.updateEntity(name, value, ['deliveryTimes'])}
                      disabled={disabled}
                    />
                  </div>
                </div>
              </div>
            </Col>
            <Col xs={12} md={inModal ? 12 : 6}>
              <div class="panel panel-transparent">
                <div class="panel-body">
                  <p className="form-group-title">{messages.identification}</p>
                  <div class="form-group-attached">
                    <FormInput
                      label='Quantity ID CreaCheck'
                      name="sku"
                      value={entity.getIdent().getSku()}
                      meta={entity.getIdent().getSkuMetaInformation()}
                      validation={entity.getIdent().getSkuValidationResult()}
                      onChange={(name, value) => this.updateEntity(name, value, ['ident'])}
                      disabled={disabled}
                    />
                    <FormInput
                      label='Quantity ID Lieferant'
                      name="vendorId"
                      value={entity.getIdent().getVendorId()}
                      meta={entity.getIdent().getVendorIdMetaInformation()}
                      validation={entity.getIdent().getVendorIdValidationResult()}
                      onChange={(name, value) => this.updateEntity(name, value, ['ident'])}
                      disabled={disabled}
                    />
                    <FormInput
                      label="Interne ID"
                      name="internal"
                      value={entity.getIdent().getInternal()}
                      meta={entity.getIdent().getInternalMetaInformation()}
                      validation={entity.getIdent().getInternalValidationResult()}
                      onChange={(name, value) => this.updateEntity(name, value, ['ident'])}
                      disabled={disabled}
                    />
                    <FormInput
                      label={messages.upc}
                      name="upc"
                      value={entity.getIdent().getUpc()}
                      meta={entity.getIdent().getUpcMetaInformation()}
                      validation={entity.getIdent().getUpcValidationResult()}
                      onChange={(name, value) => this.updateEntity(name, value, ['ident'])}
                      disabled={disabled}
                    />
                  </div>
                  <p class="m-t-10">{messages.visibility}</p>
                  <div>
                    <FormSwitchery
                      name={'isActive'}
                      checked={entity.getIsActive()}
                      value={true}
                      label={messages.show_item_online}
                      onChange={this.updateEntity}
                    />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        )}
      </div>
    );
  }
}
VariantData.defaultProps = {
  inModal: false,
};

const mapStateToProps = state => {
  return {
    attributeList: state.list.categoryAttributes,
  };
};

export default injectIntl(connect(mapStateToProps)(VariantData));
